module.exports = __webpack_public_path__ + "static/media/glance1.e8261081.jpeg";